import { render } from "./AboutView.vue?vue&type=template&id=ed5ed134&scoped=true"
const script = {}

import "./AboutView.vue?vue&type=style&index=0&id=ed5ed134&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nexascale/nexascale/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed5ed134"]])

export default __exports__